import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useUserId } from '~/context/common/UserContext';
import FinanceContext from '~/context/vdp/FinanceContext';
import fetchUserFinancing from '~/services/vdp/fetchUserFinancing';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetUserFinancing() {
  const {
    triggerUserFinancingRequest,
    userFinancing: { setData, setError, setLoading }
  } = useContext(FinanceContext);
  const userId = useUserId();

  useEffectWithController(
    controller => {
      if (!userId) return;

      setLoading();

      fetchUserFinancing(userId)
        .then(setData)
        .catch(
          generateErrorLogger(
            'Get user financing',
            {},
            { callback: setError, controller }
          )
        );
    },
    [setData, setError, setLoading, triggerUserFinancingRequest, userId]
  );
}
